<template>
    <div>
        <form @submit.prevent="submit" id="newPasswordForm" novalidate="novalidate">
            <span class="p-mb-3 p-field p-col-12 p-d-block p-d-no-padding">
                <label for="new-password" v-t="'label.newPassword'"></label>
                <InputText
                    id="new-password"
                    v-model="newPassword"
                    type="password"
                    autocomplete="new-password"
                    :class="{ invalid: errors.newPassword.length }"
                />
                <div class="input-error-container">
                    <small v-if="errors.newPassword.length" class="input-error" v-t="'errors.newPassword.' + errors.newPassword" />
                </div>
            </span>
            <span class="p-mb-3 p-field p-col-12 p-d-block p-d-no-padding">
                <label
                    for="confirm-password"
                    v-t="'label.confirmPassword'"
                ></label>
                <InputText
                    id="confirm-password"
                    v-model="confirmPassword"
                    type="password"
                    autocomplete="new-password"
                    :class="{ invalid: errors.confirmPassword.length }"
                />
                <div class="input-error-container">
                    <small v-if="errors.confirmPassword.length" class="input-error" v-t="'errors.confirmPassword.' + errors.confirmPassword" />
                </div>
            </span>
            <Button
                type="submit"
                class="p-button"
                :label="$t('button.submit')"
            ></Button>
        </form>
        <p>
            <router-link
                :to="{ name: 'login' }"
                class="forgot-password"
                v-t="'link'"
            />
        </p>
    </div>
</template>

<script>
    import Button from 'primevue/button';
    import InputText from 'primevue/inputtext';
    import encodePassword from "myra-ui-common/utils/encodePassword";
    import hasEnoughComplexity from 'myra-ui-common/utils/hasEnoughComplexity';

    export default {
        name       : 'NewPassword',
        components : { Button, InputText },
        data() {
            return {
                newPassword       : '',
                confirmPassword   : '',
                minPasswordLength : 10,
                errors            : {
                    newPassword     : '',
                    confirmPassword : '',
                }
            };
        },
        watch : {
            newPassword() {
                this.errors.newPassword = '';
            },
            confirmPassword() {
                this.errors.confirmPassword = '';
            }
        },
        computed : {
            token() {
                return this.$route.params.token;
            },
        },
        methods : {
            isFormValid() {
                let isValid = true;
                if (this.newPassword.length < 1) {
                    this.errors.newPassword = 'empty';
                    isValid = false;
                } else if (this.newPassword.length < this.minPasswordLength) {
                    this.errors.newPassword = 'tooShort';
                    isValid = false;
                } else if (!hasEnoughComplexity(this.newPassword)) {
                    this.errors.newPassword = 'notEnoughComplexity';
                    isValid = false;
                }
                if (this.confirmPassword.length < 1) {
                    this.errors.confirmPassword = 'empty';
                    isValid = false;
                } else if (this.newPassword !== this.confirmPassword) {
                    this.errors.confirmPassword = 'notSame';
                    isValid = false;
                }
                return isValid;
            },
            submit() {
                if (!this.isFormValid()) {
                    return;
                }
                const data = {
                    newPassword     : encodePassword(this.newPassword),
                    confirmPassword : encodePassword(this.confirmPassword),
                    token           : this.token,
                };
                this.$emit('submit', 'updatePassword', data, 'newLogin');
            },
        },
    };
</script>

<i18n src="myra-ui-common/i18n/common.json" />
<i18n src="./i18n.json" />
